import "@fontsource/instrument-sans/400.css";
import "@fontsource/instrument-sans/600.css";
import "@/globals.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "@/lib/sentry";
import { AppShell } from "@/components/AppShell";
import { Taskpane } from "@/routes/Taskpane";

// Init Sentry FIRST — before any React code — so render-time errors are captured.
initSentry();

function renderBootError(err: unknown) {
  const msg = err instanceof Error ? `${err.name}: ${err.message}\n\n${err.stack ?? ""}` : String(err);
  console.error("[myai bootstrap]", err);
  const root = document.getElementById("root") ?? document.body;
  root.innerHTML = `
    <div style="padding:1rem;color:#F7F8F8;background:#0A0E11;min-height:100vh;font-family:monospace;font-size:12px;line-height:1.5;white-space:pre-wrap;overflow:auto">
      <div style="color:#f85149;font-size:14px;font-weight:600;margin-bottom:0.5rem">Bootstrap error</div>
      ${msg.replace(/[<>&]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;" })[c]!)}
    </div>
  `;
}

async function bootstrap() {
  try {
    console.warn("[myai bootstrap] start; mock?", new URLSearchParams(location.search).get("mock"));

    if (import.meta.env.DEV && new URLSearchParams(location.search).get("mock") === "1") {
      console.warn("[myai bootstrap] importing MSW");
      const { startMockWorker } = await import("@/test/msw/browser");
      console.warn("[myai bootstrap] starting MSW");
      await startMockWorker();
      console.warn("[myai bootstrap] MSW started");
      if (!localStorage.getItem("myai_excel.bearer")) {
        localStorage.setItem("myai_excel.bearer", btoa("mock_mirror:mock_cred"));
      }
    }

    console.warn("[myai bootstrap] mounting React");
    const root = document.getElementById("root");
    if (!root) throw new Error("missing #root");
    createRoot(root).render(
      <StrictMode>
        <AppShell routeLabel="the taskpane">
          <Taskpane />
        </AppShell>
      </StrictMode>
    );
    console.warn("[myai bootstrap] done");
  } catch (err) {
    renderBootError(err);
  }
}

bootstrap();

// Catch unhandled promise rejections from the React tree so they show up too.
window.addEventListener("unhandledrejection", (e) => {
  renderBootError(e.reason);
});
